import {sanitizeConsultantContext} from './onboardingConsultantContext.ts';
import {describeFluScreen} from './fluScreenContext.ts';
export function voiceScreenEvent(value:unknown,id:string){
 const context=sanitizeConsultantContext(value);if(!context)return null;
 return {type:'conversation.item.create',item:{type:'message',id,role:'system',content:[{type:'input_text',text:'Aggiornamento silenzioso del contesto interfaccia. Non rispondere né produrre audio per questo aggiornamento. Usalo solo per la prossima richiesta dell’utente. '+describeFluScreen(context)}]}};
}
